import React, { useState, ReactElement } from 'react'
import { FAQCardProps } from '@mindfulchefuk/components/FAQ/Card/FAQCard.types'
import {
  Icon,
  Text,
  ResetButton,
  Stack,
  Flex,
} from '@mindfulchefuk/design-system'

export const FAQCard = ({
  question,
  answer,
  onClickTracking,
}: FAQCardProps): ReactElement => {
  const [isOpen, setOpen] = useState<boolean>(false)

  const onCardClick = () => {
    if (onClickTracking && !isOpen) onClickTracking(question)
    setOpen((open) => !open)
  }

  return (
    <ResetButton fullWidth data-testid="faq-card" onClick={onCardClick}>
      <Stack
        p={32}
        marginBottom={20}
        spacing={16}
        borderWidth={1}
        borderRadius={10}
        borderColor="aubergine"
        backgroundColor="salt"
        textAlign="left"
      >
        <Flex justify="space-between">
          <Text variant="body-lg-500-caps" color="aubergine">
            {question}
          </Text>

          <Icon
            color="aubergine"
            minWidth={20}
            size={20}
            type={isOpen ? 'chevron-down' : 'chevron-right'}
          />
        </Flex>
        {isOpen && (
          <Text
            as="p"
            variant="body-sm"
            data-testid="answer-text"
            color="pepper"
          >
            {answer}
          </Text>
        )}
      </Stack>
    </ResetButton>
  )
}
